import { gql } from 'graphql-request'

export const UPLOAD_FILE = gql`
  mutation UploadChallengePhoto($file: Upload!) {
    uploadChallengePhoto(file: $file) {
      filePath
    }
  }
`
